<template>
    <div v-if="dateViewRole">
        <van-nav-bar title="报表" fixed/>

        <!-- 目标 -->
        <h2 class="line-title mp60 iconMenu" id="test3">
            <span>本月目标</span>
        </h2>
        <div style="margin:10px">
            <canvas id="target" style="width: 100%;height: 200px"></canvas>
        </div>

        <!-- 三个维度业务数据 -->
        <h2 class="line-title iconMenu">
            <span>业务数据</span>
        </h2>
        <van-tabs v-model="active" sticky :lazy-render="false" type="line" style="margin-bottom: 40px">
            <van-tab title="本日">
                <div class="layer1">
                    <span class="title">放款金额</span>
                    <span class="amt">¥ {{topData4.days | changeMoney}}</span>
                </div>
                <div class="layer2">
                    <div class="item">
                        <span>新增客户</span>
                        <span class="num">{{topData1.days}}个</span>
                    </div>
                    <div class="link-right"></div>
                    <div class="item">
                        <span>进件数量</span>
                        <span class="num">{{topData2.days}}笔</span>
                    </div>
                    <div class="link-right"></div>
                    <div class="item">
                        <span>放款笔数</span>
                        <span class="num">{{ topData3.days }}笔</span>
                    </div>
                </div>
            </van-tab>
            <van-tab title="本周">
                <div class="layer1">
                    <span class="title">放款金额</span>
                    <span class="amt">¥ {{topData4.weeks | changeMoney}}</span>
                </div>
                <div class="layer2">
                    <div class="item">
                        <span>新增客户</span>
                        <span class="num">{{topData1.weeks}}个</span>
                    </div>
                    <div class="link-right"></div>
                    <div class="item">
                        <span>进件数量</span>
                        <span class="num">{{topData2.weeks}}笔</span>
                    </div>
                    <div class="link-right"></div>
                    <div class="item">
                        <span>放款笔数</span>
                        <span class="num">{{ topData3.weeks }}笔</span>
                    </div>
                </div>
            </van-tab>
            <van-tab title="总览">
                <div class="layer1">
                    <span class="title">放款金额</span>
                    <span class="amt">¥ {{topData4.numbers | changeMoney}}</span>
                </div>
                <div class="layer2">
                    <div class="item">
                        <span>总客户</span>
                        <span class="num">{{topData1.numbers}}</span>
                    </div>
                    <div class="link-right"></div>
                    <div class="item">
                        <span>进件数量</span>
                        <span class="num">{{topData2.numbers}}笔</span>
                    </div>
                    <div class="link-right"></div>
                    <div class="item">
                        <span>放款笔数</span>
                        <span class="num">{{topData3.numbers}}笔</span>
                    </div>
                </div>
            </van-tab>
        </van-tabs>

        <h2 class="line-title iconMenu">
            <span>业务放款(万)</span>
            <div class="iconContent" @click="changeYearShow=true">
                <span class="year">{{year}}</span>
                <van-icon name="tosend" style="margin: 0 10px"/>
            </div>
        </h2>
        <canvas id="barContainer" style="width: 100%;height: 200px; margin-bottom: 80px"></canvas>

        <h2 class="line-title iconMenu">
            <span>累计放款规模</span>
        </h2>
        <canvas id="pie1" style="width: 100%;height: 200px; margin-bottom: 80px"></canvas>

        <h2 class="line-title iconMenu">
            <span>在贷规模</span>
        </h2>
        <canvas id="pie2" style="width: 100%;height: 200px; margin-bottom: 80px"></canvas>

        <!-- 年份选择 -->
        <van-popup v-model="changeYearShow" position="bottom">
            <van-picker
                    title="请选择年度"
                    show-toolbar
                    :columns="columns"
                    @confirm="onConfirm"
                    @cancel="changeYearShow=false"
                    @change="onChange"
            />
        </van-popup>
    </div>
</template>

<script>
    import F2 from '@antv/f2/lib/index-all';
    //const F2 = require('@antv/f2/lib/index')
    import { getScaleData,getCustomerData,getApplyData,getLoanData,getLoanAmountData,getSimpleData,getLoanAmountByMonth } from '@/api/monitoring'
    import insertCss from 'insert-css';
    import moment from 'moment';
    import {mapGetters} from "vuex";

    insertCss(`
      canvas.guage {
        border-radius: 5px;
        background-color: #1890ff;
        background-image: linear-gradient(#246BFF, #2797FF);
      }
    `);
    const {
        Shape,
        G,
        Util,
        Global
    } = F2;
    const Vector2 = G.Vector2;


    export default {
        name: 'menus',
        components: {},
        computed: mapGetters([
            'roles'
        ]),
        data: function () {
            return {
                dateViewRole: false,// 过滤角色
                active: '0',
                changeYearShow: false,
                columns: [],
                year: moment().format('YYYY'),
                customerData: [],
                groupData: [],// 柱状图数据
                targetAmount: 0,// 目标
                scale: 0,// 完成度
                /* 图表实例*/
                targetChart: null,
                loanChart: null,
                /**/
                topData1: {
                    numbers: '',
                    days: '',
                    weeks: '',
                    months: ''
                },
                topData2: {
                    numbers: '',
                    days: '',
                    weeks: '',
                    months: ''
                },
                topData3: {
                    numbers: '',
                    days: '',
                    weeks: '',
                    months: ''
                },
                topData4: {
                    numbers: '',
                    days: '',
                    weeks: '',
                    months: ''
                },
                pieData1: [],
                pieData2: []
            }
        },
        methods: {
            onConfirm(value) {
                const self = this
                this.year = value
                this.changeYearShow = false
                this.handleLoanAmt(true)
            },
            onCancel() {

            },
            onChange() {

            },
            // 业务放款
            init() {
                // Step 1: 创建 Chart 对象
                this.loanChart = new F2.Chart({
                    id: 'barContainer',
                    pixelRatio: window.devicePixelRatio // 指定分辨率
                });

                // Step 2: 载入数据源
                this.loanChart.source(this.groupData, {
                    sales: {
                        tickCount: 12
                    }
                });
                this.loanChart.legend(false)
                // Step 3：创建图形语法，绘制柱状图，由 genre 和 sold 两个属性决定图形位置，genre 映射至 x 轴，sold 映射至 y 轴
                this.loanChart.interval()
                    .position('month*amount')
                //.color('genre');

                this.loanChart.tooltip({
                    showItemMarker: false
                });

                // Step 4: 渲染图表
                this.loanChart.render();
            },
            init2() {
                // 设置独立的css
                const self = this
                const container = document.getElementById('target');
                container.className = 'guage';
                Shape.registerShape('interval', 'polar-tick', {
                    draw: function draw(cfg, container) {
                        const points = this.parsePoints(cfg.points);
                        const style = Util.mix({
                            stroke: cfg.color
                        }, Global.shape.interval, cfg.style);

                        let newPoints = points.slice(0);
                        if (this._coord.transposed) {
                            newPoints = [points[0], points[3], points[2], points[1]];
                        }

                        const center = cfg.center;
                        const x = center.x,
                            y = center.y;
                        const v = [1, 0];
                        const v0 = [newPoints[0].x - x, newPoints[0].y - y];
                        const v1 = [newPoints[1].x - x, newPoints[1].y - y];
                        const v2 = [newPoints[2].x - x, newPoints[2].y - y];

                        let startAngle = Vector2.angleTo(v, v1);
                        let endAngle = Vector2.angleTo(v, v2);
                        const r0 = Vector2.length(v0);
                        const r = Vector2.length(v1);

                        if (startAngle >= 1.5 * Math.PI) {
                            startAngle = startAngle - 2 * Math.PI;
                        }

                        if (endAngle >= 1.5 * Math.PI) {
                            endAngle = endAngle - 2 * Math.PI;
                        }

                        const lineWidth = r - r0;
                        const newRadius = r - lineWidth / 2;

                        return container.addShape('Arc', {
                            className: 'interval',
                            attrs: Util.mix({
                                x,
                                y,
                                startAngle,
                                endAngle,
                                r: newRadius,
                                lineWidth,
                                lineCap: 'round'
                            }, style)
                        });
                    }
                });
                const data = [{
                    const: 'a',
                    actual: self.scale,
                    expect: 100
                }];
                this.targetChart = new F2.Chart({
                    id: 'target',
                    padding: [0, 30, 60],
                    pixelRatio: window.devicePixelRatio
                });
                this.targetChart.source(data, {
                    actual: {
                        max: 100,
                        min: 0,
                        nice: false
                    }
                });
                this.targetChart.coord('polar', {
                    transposed: true,
                    innerRadius: 0.8,
                    startAngle: -Math.PI,
                    endAngle: 0
                });
                this.targetChart.axis(false);
                this.targetChart.interval()
                    .position('const*expect')
                    .shape('polar-tick')
                    .size(10)
                    .color('rgba(80, 143, 255, 0.95)')
                    .animate(false); // 背景条
                this.targetChart.interval()
                    .position('const*actual')
                    .shape('polar-tick')
                    .size(10)
                    .color('#fff')
                    .animate({
                        appear: {
                            duration: 1100,
                            easing: 'linear',
                            animation: function animation(shape, animateCfg) {
                                const startAngle = shape.attr('startAngle');
                                let endAngle = shape.attr('endAngle');
                                if (startAngle > endAngle) {
                                    // -Math.PI/2 到 0
                                    endAngle += Math.PI * 2;
                                }
                                shape.attr('endAngle', startAngle);
                                shape.animate().to(Util.mix({
                                    attrs: {
                                        endAngle
                                    }
                                }, animateCfg)).onUpdate(function (frame) {
                                    const textEl = document.querySelector('#text');
                                    if (textEl) textEl.innerHTML = parseInt(frame * self.scale) + '%';
                                });
                            }
                        }
                    }); // 实际进度
                let amt = self.targetAmount
                this.targetChart.guide().html({
                    position: ['50%', '80%'],
                    html: `
                        <div style="width: 120px;color: #fff;white-space: nowrap;text-align:center;">
                          <p style="font-size: 16px;margin:0;">本月目标</p>
                          <p style="font-size: 13px;margin:2px 0;">`+amt+`万</p>
                          <p id="text" style="font-size: 48px;margin:0;font-weight: bold;">0</p>
                        </div>`
                });
                this.targetChart.render();

            },
            init3() {
                const chart = new F2.Chart({
                    id: 'pie1',
                    pixelRatio: window.devicePixelRatio
                });
                chart.source(this.pieData1);
                chart.coord('polar', {
                    transposed: true,
                    radius: 0.9,
                    innerRadius: 0.5
                });
                chart.axis(false);
                chart.legend(false);
                chart.tooltip(false);
                chart.guide()
                    .html({
                        position: [ '50%', '50%' ],
                        html: '<div style="text-align: center;width:150px;height: 50px;">\n      <p style="font-size: 12px;color: #999;margin: 0" id="title"></p>\n      <p style="font-size: 18px;color: #343434;margin: 0;font-weight: bold;" id="money"></p>\n      </div>'
                    });
                chart.interval()
                    .position('const*amount')
                    .adjust('stack')
                    .color('productName', [ '#1890FF', '#13C2C2', '#2FC25B', '#FACC14' ]);
                chart.pieLabel({
                    sidePadding: 30,
                    activeShape: true,
                    label1: function label1(data) {
                        return {
                            text: '￥' + data.amount,
                            fill: '#343434',
                            fontWeight: 'bold'
                        };
                    },
                    label2: function label2(data) {
                        return {
                            text: data.productName,
                            fill: '#999'
                        };
                    },
                    onClick: function onClick(ev) {
                        const data = ev.data;
                        if (data) {
                            //$('#title').text(data.type);
                            //$('#money').text(data.money);
                        }
                    }
                });
                chart.render();
            },
            init4() {
                const chart = new F2.Chart({
                    id: 'pie2',
                    pixelRatio: window.devicePixelRatio
                });
                chart.source(this.pieData2);
                chart.coord('polar', {
                    transposed: true,
                    radius: 0.9,
                    innerRadius: 0.5
                });
                chart.axis(false);
                chart.legend(false);
                chart.tooltip(false);
                chart.guide()
                    .html({
                        position: [ '50%', '50%' ],
                        html: '<div style="text-align: center;width:150px;height: 50px;">\n      <p style="font-size: 12px;color: #999;margin: 0" id="title"></p>\n      <p style="font-size: 18px;color: #343434;margin: 0;font-weight: bold;" id="money"></p>\n      </div>'
                    });
                chart.interval()
                    .position('const*amount')
                    .adjust('stack')
                    .color('productName', [ '#1890FF', '#13C2C2', '#2FC25B', '#FACC14' ]);
                chart.pieLabel({
                    sidePadding: 30,
                    activeShape: true,
                    label1: function label1(data) {
                        return {
                            text: '￥' + data.amount,
                            fill: '#343434',
                            fontWeight: 'bold'
                        };
                    },
                    label2: function label2(data) {
                        return {
                            text: data.productName,
                            fill: '#999'
                        };
                    },
                    onClick: function onClick(ev) {
                        const data = ev.data;
                        if (data) {

                        }
                    }
                });
                chart.render();
            },
            initYearData(){
                // 初始化16年起到今年的年份集合
                let lastYear = moment().format('YYYY')
                this.year = lastYear
                let value = lastYear - 2016
                for(let i=0;i<=value;i++){
                    let year = 2016 + i
                    this.columns.push(year)
                }
                this.columns.reverse()
            },
            handleCustomerData () {
                getCustomerData({}).then(res => {
                    if (res.success) {
                        this.topData1 = res.data
                    }
                })
            },
            handleApplyData () {
                getApplyData({}).then(res => {
                    if (res.success) {
                        this.topData2 = res.data
                    }
                })
            },
            handleLoanData () {
                getLoanData({}).then(res => {
                    if (res.success) {
                        this.topData3 = res.data
                    }
                })
            },
            handleLoanAmountData () {
                getLoanAmountData({}).then(res => {
                    if (res.success) {
                        this.topData4 = res.data
                    }
                })
            },
            handleScaleData () {
                getScaleData({}).then(res => {
                    if (res.success) {
                        this.pieData1 = []
                        this.pieData2 = []
                        res.data.p1.forEach(item=>{
                            this.pieData1.push({
                                const: 'const',
                                productName: item.productName,
                                amount: item.amount
                            })
                        })
                        res.data.p2.forEach(item=>{
                            this.pieData2.push({
                                const: 'const',
                                productName: item.productName,
                                amount: item.amount
                            })
                        })
                    }
                })
            },
            handleLoanAmt(isChange){
                getLoanAmountByMonth({year:this.year}).then(res => {
                    if (res.success) {
                        const _data = []
                        for (let i = 1; i <= 12; i++) {
                            let amt = res.data.loanAmountByMonth[i + '月']
                            if(amt > 10000){
                                amt = (amt/10000).toFixed(1)
                            }
                            _data.push({
                                month: i + '月',
                                amount: parseFloat(amt)
                            })
                        }
                        this.groupData = _data
                        this.targetAmount = parseInt(res.data.loanTargetByMonth.targetAmount) > 10000 ? res.data.loanTargetByMonth.targetAmount /10000 : res.data.loanTargetByMonth.targetAmount
                        this.scale = res.data.scale

                        // 初始化报表
                        if(!isChange){
                            this.init()
                            this.init2()
                        }else{
                            this.targetChart.changeData(this.scale)
                            this.loanChart.changeData(this.groupData) // 重新渲染数据
                        }



                    }
                })
            }
        },
        mounted() {
            const self = this
            this.roles.forEach(item=>{
                if(item === 'DATA_VIEW'){
                    self.dateViewRole = true
                }
            })
            if(self.dateViewRole){
                self.handleCustomerData()
                self.handleApplyData()
                self.handleLoanData()
                self.handleLoanAmountData()
                self.handleLoanAmt(false)
                self.handleScaleData()
                setTimeout(()=>{
                    self.initYearData()
                    self.init3()
                    self.init4()
                },1000)
            }

        }
    }
</script>

<style scoped>
    .layer1 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .layer1 .title {
        margin-top: 20px;
    }

    .layer1 .amt {
        font-weight: bold;
        font-size: 18px;
        margin-top: 4px;
    }

    .layer2 {
        display: flex;
        margin-top: 10px;
    }

    .layer2 .item {
        width: 33%;
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 10px;
    }

    .layer2 .item .num {
        margin-top: 4px;
    }

    .link-right {
        border: solid #ccc;
        border-width: 0 1px 1px 0;
        display: inline-block;
    }

    .line-title {
        margin: 0;
        margin: 16px 6px 6px 16px;
        color: rgba(69, 90, 100, 0.6);
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
    }

    .mp60 {
        margin-top: 60px;
    }

    .iconMenu {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .year {
        font-weight: bold;
    }

    .iconContent {
        display: flex;
        align-items: center;
    }
</style>
